import { useMediaQuery } from '@mui/material'
import { WarningIcon } from '@assets/svgs/WarningIcon'
import { UserGear } from '@phosphor-icons/react'
import { Title } from '@components/shared/Title'
import { emotionTheme } from '@styles/theme'

import type { SimulationsHeaderProps } from './types'

import * as S from './styles'

export const SimulationsHeader = ({ onNewSimulation, canEditSimulations = true }: SimulationsHeaderProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  return (
    <S.Container>
      <S.Title>Simulações</S.Title>
      <S.Subtitle>Gerencie suas simulações de admissão e rescisão</S.Subtitle>
      <S.WarningBanner>
        <S.WarningIconContainer>
          <WarningIcon />
        </S.WarningIconContainer>
        <S.WarningText>
        Lembre-se de verificar se a simulação de admissão já foi efetivada no sistema e consta na lista de colaboradores. Em caso afirmativo, clique no ícone da lixeira para excluir da lista de simulações.
        Para simulações de rescisões indenizadas, os valores na listagem do colaborador serão zerados. Os valores do respectivo colaborador são mantidos no “Detalhe do Colaborador”.
        </S.WarningText>
      </S.WarningBanner>
      
      <Title
        label="Simulações Cadastradas"
        marginTop={24}
        marginBottom={24}
        action={
          onNewSimulation ? (
            <S.CustomButton
              width={isMobile ? '100%' : 190}
              onClick={onNewSimulation}
              disabled={!canEditSimulations}
            >
              <UserGear size={22} weight="regular" />
              Nova Simulação
            </S.CustomButton>
          ) : undefined
        }
      />
    </S.Container>
  )
}
